import React from 'react';

import {
  CollectionsContext,
  CollectionsContextValues
} from '@smart-tv/contexts/collections-context/collections-context';

export const useCollections = (): CollectionsContextValues => {
  const values = React.useContext(CollectionsContext);

  return { ...values };
};

export default useCollections;
